// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const FOOTER = 'footer';

const styles = css`
  text-align: center;
  width: 100%;
  ${(props) =>
    props.isFooterRedesignEnabled &&
    `
    display: flex;
    justify-content: space-between;
    `}
  .button-container {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    margin: ${(props) =>
        props.smsFromPage === FOOTER
          ? props.theme.spacing.ELEM_SPACING.MED
          : props.theme.spacing.ELEM_SPACING.XL}
      auto ${(props) => (props.smsFromPage === FOOTER ? '20px' : 0)};

    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `
        margin-bottom: 12px;
         margin-top: 24px;
        `}
    }
  }

  .tapToJoin-cta {
    width: 200px;
    padding: 0px;
    -webkit-tap-highlight-color: transparent;
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      ${(props) => !props.isFooterRedesignEnabled && `width: 192px;`}
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `
        color: #FFF;
font-family: Nunito;
font-size: 10px;
font-style: normal;
font-weight: 800;
line-height: normal;
letter-spacing: 0.05px;
border-radius: 6px;
background: #000;
width: unset;
padding: 10px;
text-transform: capitalize;
min-width:104px;

        `}
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      ${(props) => props.isFooterRedesignEnabled && `min-width: 75px;`}
    }
  }

  .tapToJoin-cta:focus {
    background-color: ${(props) => props.theme.colors.WHITE};
    outline: none;
  }

  .tapToJoin-cta:hover {
    border: solid 1px ${(props) => props.theme.colors.TEXT.GRAY};
    background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
    color: ${(props) => props.theme.brandSpecificStyles.TTJ_BUTTON_TEXT_COLOR};
  }

  .anchor {
    text-decoration: none;
    display: inline-block;
  }

  .tap-to-join-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tap-to-join-blue-image {
    width: 43px;
    height: 57px;
  }
  .tap-to-join-black-image {
    padding-top: 25px;
    width: 31px;
    height: 36px;
  }
  .tap-to-join-text-copy {
    text-transform: uppercase;
    ${(props) => (props.smsFromPage !== FOOTER ? 'max-width: 210px;' : '')}
    text-align: left;
    flex-wrap: wrap;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `
    width:100%;
     text-transform: capitalize;
      `}
    }
  }
  .sms_body_text_extra {
    text-align: center;
    margin-top: 16px;
  }
  .sms_body_text_off {
    letter-spacing: -0.3px;
    color: ${(props) => props.theme.colorPalette.primary.main};
  }
  .sms_body_text_join,
  .sms_body_text_off {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `
      color: #000;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
      `}
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `font-size: 14px;
      color: #003057;
      font-weight: 800;
        `}
    }
  }
`;

export default styles;
